import React from 'react';
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { CSVLink } from "react-csv";
import moment from 'moment';
import Button from '@material-ui/core/Button';



// function descendingComparator(a, b, orderBy) {
//     if (b[orderBy] < a[orderBy]) {
//         return -1;
//     }
//     if (b[orderBy] > a[orderBy]) {
//         return 1;
//     }
//     return 0;
// }

// function getComparator(order, orderBy) {
//     return order === 'desc'
//         ? (a, b) => descendingComparator(a, b, orderBy)
//         : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//     const stabilizedThis = array.map((el, index) => [el, index]);
//     stabilizedThis.sort((a, b) => {
//         const order = comparator(a[0], b[0]);
//         if (order !== 0) return order;
//         return a[1] - b[1];
//     });
//     return stabilizedThis.map((el) => el[0]);
// }

const headCells = [
    { id: 'referringConsumerId', disablePadding: true, label: 'Referring Consumer Id' },
    { id: 'referringConsumerName', disablePadding: true, label: 'Referring Consumer Name' },
    { id: 'referringUserMobileNumber', disablePadding: true, label: 'Referring User Mobile No' },
    { id: 'referralCode', disablePadding: true, label: 'Referral Code' },
    { id: 'referredConsumerId', disablePadding: true, label: 'Referred Consumer Id' },
    { id: 'referredConsumerName', disablePadding: true, label: 'Referred Consumer Name' },
    { id: 'referredUserMobileNumber', disablePadding: true, label: 'Referred User Mobile No' },
    { id: 'dateOfRegistration', disablePadding: false, label: 'Registered Date' },
    { id: 'couponIssuedStatus', disablePadding: false, label: 'Coupon issued to Referring user(Yes/No)' }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        className={classes.tableCellSmall}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%'
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    let csvData = []
    props.data.forEach(element => {
        let obj = element
        obj.dateOfInvite = (moment(obj.dateOfInvite).format('DD MMM YYYY hh:mm A'))
        csvData.push(obj)
    });

    return (
        <Toolbar style={{ paddingLeft: "16px" }}>
            <Typography className={classes.title} variant="subtitle2" id="tableTitle" component="div">
                Referral Report ({props.total})
            </Typography>

            <Typography component="div">
                {props.showDownloadIcon ?
                    <CSVLink
                        data={csvData}
                        headers={props.headers}
                        filename={"referrals.csv"}
                        className="btn btn"
                        target="_blank"
                    >
                        <Tooltip title="Export to Excel">
                            <img alt="Export To Excel" src="../../images/exportToExcel.png" width="25" height="25" />
                        </Tooltip>
                    </CSVLink>
                    :
                    <Button
                        variant="contained"
                        margin="normal"
                        style={{ backgroundColor: "green", color: "white", fontFamily: "bold" }}
                        onClick={props.fetchInvitesExcelFile}
                    >
                        Export
                </Button>
                }
            </Typography>
        </Toolbar>
    );
};

/* EnhancedTableToolbar.propTypes = {
    exportToExcel: PropTypes.func.exportToExcel,
    total: PropTypes.number.isRequired
}; */

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    tableCellSmall: {
        fontSize: "12px",
        padding: "6px 0px 6px 16px"
    },
    tableRow: {
        // cursor: 'pointer'
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
}));

export default function EnhancedTable(props) {
    const classes = useStyles();

    const handleInvitesSort = (event, property) => {
        const isAsc = props.orderBy === property && props.order === 'asc';
        props.setOrder(isAsc ? -1 : 1);
        props.setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        props.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        props.setRowsPerPage(parseInt(event.target.value, 10));
        props.setPage(0);
    };

    let headers = [
        { key: 'referringConsumerId', label: 'Referring Consumer Id' },
        { key: 'referringConsumerName', label: 'Referring Consumer Name' },
        { key: 'referringUserMobileNumber', label: 'Referring User Mobile No' },
        { key: 'referralCode', label: 'Referral Code' },
        { key: 'referredConsumerId', label: 'Referred Consumer Id' },
        { key: 'referredConsumerName', label: 'Referred Consumer Name' },
        { key: 'referredUserMobileNumber', label: 'Referred User Mobile No' },
        { key: 'dateOfRegistration', label: 'Registered Date' },
        { key: 'couponIssuedStatus', label: 'Coupon issued to Referring user(Yes/No)'},
    ];

    let data = props.data;
    data.exportData && data.exportData.forEach(item => {
        item.couponIssuedStatus = item.referringUserCouponCode && item.referringUserCouponCode.length>0  ? 'Yes' : 'No';
        item.referringConsumerId=item.consumerId;
        item.referringConsumerName=item.referredByName;
        item.referringUserMobileNumber=item.referredByMobileNumber;
        item.referredConsumerName=item.firstName+" "+ item.lastName;
        item.referredUserMobileNumber=item.referredMobileNumber;
        item.dateOfRegistration=item.dateOfInvite;
    });

    const emptyRows = props.rowsPerPage - Math.min(props.rowsPerPage, props.data.total - props.page * props.rowsPerPage);

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar
                    total={props.data.total}
                    headers={headers}
                    data={data.exportData}
                    // data={props.data.exportToExcel}
                    showDownloadIcon={props.showDownloadIcon}
                    fetchInvitesExcelFile={props.fetchInvitesExcelFile}

                />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size="small"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={props.order}
                            orderBy={props.orderBy}
                            onRequestSort={handleInvitesSort}
                            rowCount={props.data.total}
                        />
                        <TableBody>
                            {/* {stableSort(props.data.data, getComparator(props.order, props.orderBy)) */}
                                {/* // .slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage) */}
                                {props.data.data.map((row, index) => {
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            className={classes.tableRow}
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={index+row._id+index}
                                        >
                                            <TableCell align="left" >{row.consumerId}</TableCell>
                                            <TableCell align="left" >{row.referredBy.name}</TableCell>
                                            <TableCell align="left"  >{row.referredByMobileNumber}</TableCell>
                                            <TableCell align="left" >{row.referralCode}</TableCell>
                                            <TableCell align="left" >{row.referredConsumerId}</TableCell>
                                            <TableCell component="th" id={labelId} scope="row">{(row.firstName?row.firstName:"") + " " + (row.lastName?row.lastName:"NA")}</TableCell>
                                            <TableCell align="left" >{row.referredMobileNumber}</TableCell>
                                            <TableCell align="left">{moment(row.dateOfInvite).format('DD MMM YYYY hh:mm A')}</TableCell>
                                            <TableCell align="left" >{row.referringUserCouponCode && row.referringUserCouponCode.length>0 ? 'Yes' : 'No'}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 33 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                    component="div"
                    count={props.data.total}
                    rowsPerPage={props.rowsPerPage}
                    page={props.page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
}